module.exports = __webpack_public_path__ + "img/dummyprod4@2x.9a7bc040.png";